import { toggle } from "./toggle";

export default toggle("network-enabled");
